import { RegionSetFilter } from "@app/exports/exportModels";
import { NetworkAssessmentAnalysisType } from "@app/projects/enumerators";
import { QESRadioButton, QESRadioGroup } from "@app/shared/qes-standards";
import { JSX } from "react";

interface SelectStatusFilterProps {
  disabled: boolean;
  onNetworkAssessmentAnalysisTypeChange: (networkAssessmentAnalysisType: NetworkAssessmentAnalysisType) => void;
  regionSetFilter: RegionSetFilter;
  testIdSuffix: string;
}

export default function SelectStatusFilter(props: SelectStatusFilterProps): JSX.Element {
  const networkAssessmentAnalysisType = props.regionSetFilter.networkAssessmentAnalysisType;

  const isOpportunityAnalysisType =
    [NetworkAssessmentAnalysisType.Opportunity,
    NetworkAssessmentAnalysisType.ProjectedOpportunity,
    NetworkAssessmentAnalysisType.TermedOpportunity,
    NetworkAssessmentAnalysisType.ProjectedTermedOpportunity].includes(networkAssessmentAnalysisType);

  return (
    <QESRadioGroup groupContainerClass="col-12 mt0">
      <QESRadioButton
        label="Current Service Area"
        disabled={props.disabled}
        value="current"
        checked={!isOpportunityAnalysisType}
        onChange={() => { props.onNetworkAssessmentAnalysisTypeChange(NetworkAssessmentAnalysisType.ServiceArea); }}
        testId={`select-status-filter__current-service-area--${props.testIdSuffix}`}
      />
      <QESRadioButton
        label="Opportunities to Expand"
        disabled={props.disabled}
        value="opportunity"
        checked={isOpportunityAnalysisType}
        onChange={() => { props.onNetworkAssessmentAnalysisTypeChange(NetworkAssessmentAnalysisType.Opportunity); }}
        testId={`select-status-filter__opportunity--${props.testIdSuffix}`}
      />
    </QESRadioGroup>
  );
}
